export default __webpack_public_path__ + "static/media/hills-with-white-notch.80f5b154.svg";